import {$q1, $qAll} from "../ui-scripts/dom-helpers";


function expandables () {

	const expandableItems = $qAll('.js-expandable-item');

	for(let i = 0; i < expandableItems.length; i ++) {
		let currExpandable = expandableItems[i];
		console.log(currExpandable);

		let expTrigger = $q1('.js-expandable-trigger', currExpandable);

		expTrigger.addEventListener('click', () => {

			console.log('clicked :' + currExpandable);

			currExpandable.classList.toggle('is-expanded');

		})
	}

}

export {expandables}
